import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Gift, Copy, Check, Users } from "lucide-react";
import api from "@/lib/api";

export default function Refer() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/referral").then((r) => setData(r.data)).catch(() => {}); }, []);

  const link = data ? `${window.location.origin}/login?ref=${data.code}` : "";
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); setCopied(true); toast.success("Link copied!"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Copy failed — select and copy manually."); }
  };

  return (
    <div className="min-h-screen bg-[#070d1c] text-slate-100" style={{ backgroundImage: "radial-gradient(700px circle at 50% -5%, rgba(16,185,129,0.12), transparent 60%)" }}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <button data-testid="refer-back" onClick={() => navigate("/")} className="flex items-center gap-2 text-sm text-slate-400 hover:text-emerald-300 transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <div className="w-14 h-14 rounded-2xl bg-emerald-500/15 grid place-items-center mb-5"><Gift className="w-7 h-7 text-emerald-400" /></div>
        <h1 className="text-4xl font-bold tracking-tight">Give a month, <span className="text-emerald-400">get a month</span></h1>
        <p className="text-slate-400 mt-3">Share your link. When a friend subscribes to any paid plan, you get <strong className="text-white">one free month</strong> credited automatically. No limit.</p>

        <div className="mt-8 bg-[#0d1730] border border-white/10 rounded-2xl p-6">
          <p className="text-[11px] uppercase tracking-wider text-slate-500 mb-2">Your referral link</p>
          <div className="flex items-center gap-2">
            <input data-testid="refer-link" readOnly value={link} className="flex-1 h-11 px-3 rounded-lg bg-[#070d1c] border border-white/10 text-sm font-mono text-slate-200 truncate" />
            <button data-testid="refer-copy" onClick={copy} className="h-11 px-4 rounded-lg bg-emerald-500 text-[#04140c] text-sm font-semibold flex items-center gap-2 hover:bg-emerald-400 transition-colors">
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />} {copied ? "Copied" : "Copy"}
            </button>
          </div>
          <div className="grid grid-cols-2 gap-4 mt-6">
            <div className="rounded-xl bg-white/5 p-4"><p className="text-[11px] uppercase tracking-wider text-slate-500 flex items-center gap-1"><Users className="w-3 h-3" /> Friends joined</p><p className="text-2xl font-bold font-mono mt-1" data-testid="refer-count">{data?.count ?? "—"}</p></div>
            <div className="rounded-xl bg-white/5 p-4"><p className="text-[11px] uppercase tracking-wider text-slate-500 flex items-center gap-1"><Gift className="w-3 h-3" /> Free months earned</p><p className="text-2xl font-bold font-mono mt-1 text-emerald-400" data-testid="refer-credits">{data?.credits ?? "—"}</p></div>
          </div>
        </div>
      </div>
    </div>
  );
}
